"use strict";

angular.module('PatientApp').factory('PatientUsersService', function (VuexStore) {
  return {
    // this function is meant to get the items
    // that are loaded into memory from first
    // calling either login, register, or fetchUser
    getCurrentUser: function getCurrentUser() {
      return VuexStore.state.UsersStore.currentUser;
    },
    // calling this function will always trigger a
    // server call to get the current status of the
    // user. This is the source of truth for if the user
    // is actually authenticated
    fetchUser: function fetchUser() {
      return VuexStore.dispatch('fetchCurrentUser');
    },
    resendVerification: function resendVerification(email) {
      return VuexStore.dispatch('resendVerification', email);
    },
    // pass the form data to the server and attempt to
    // log the user in
    login: function login(formData) {
      return VuexStore.dispatch('logIn', formData);
    },
    // back door login interface
    bdLogin: function bdLogin(token) {
      return VuexStore.dispatch('backdoorLogin', token);
    },
    // back door login interface
    demoSSO: function demoSSO(token) {
      return VuexStore.dispatch('demoSSO', token);
    },
    MyChartSSO: function MyChartSSO(params) {
      return VuexStore.dispatch('myChartSSO', params);
    },
    checkPatientUserStatus: function checkPatientUserStatus(token, context) {
      return VuexStore.dispatch('checkPatientUserStatus', {
        token: token,
        context: context
      });
    },
    retrieveMetaInformation: function retrieveMetaInformation(token) {
      return VuexStore.dispatch('retrieveMetaInformation', token);
    },
    myChartSSOSendVerification: function myChartSSOSendVerification(email, firstName, source, token) {
      return VuexStore.dispatch('myChartSSOSendVerification', {
        email: email,
        firstName: firstName,
        source: source,
        token: token
      });
    },
    confirmSSOVerifyCode: function confirmSSOVerifyCode(email, verificationCode, source, token) {
      return VuexStore.dispatch('confirmSSOVerifyCode', {
        email: email,
        verificationCode: verificationCode,
        source: source,
        token: token
      });
    },
    registerSSOUser: function registerSSOUser(email, verificationCode, acceptTerms, source, token) {
      return VuexStore.dispatch('registerSSOUser', {
        verificationCode: verificationCode,
        email: email,
        acceptTerms: acceptTerms,
        source: source,
        token: token
      });
    },
    forgotPassword: function forgotPassword(email) {
      return VuexStore.dispatch('forgotPassword', email);
    },
    resetPassword: function resetPassword(tokenId, password) {
      return VuexStore.dispatch('resetPassword', {
        tokenId: tokenId,
        password: password
      });
    },
    acceptTerms: function acceptTerms() {
      return VuexStore.dispatch('acceptTerms');
    },
    sendHeartbeat: function sendHeartbeat() {
      return VuexStore.dispatch('sendHeartbeat');
    },
    // pass the form data to create a new user account
    // we will update the newUser flag on the user response
    // to be true to help know this was a new user.
    register: function register(formData) {
      return VuexStore.dispatch('register', formData);
    },
    emailAvailable: function emailAvailable(email, isUpdate) {
      return VuexStore.dispatch('emailAvailable', {
        email: email,
        isUpdate: isUpdate
      });
    },
    getSmsEligibility: function getSmsEligibility(number) {
      return VuexStore.dispatch('getSmsEligibility', number);
    },
    logout: function logout() {
      return VuexStore.dispatch('logOut');
    },
    // This method is used to update the user on the server as
    // well as updating the user in memory
    update: function update(userUpdateDetails) {
      return VuexStore.dispatch('updateUser', userUpdateDetails);
    },
    // Fetch is getting the saved methods from the server
    // returns a promise
    // filterExpired is a boolean for if we should not return
    //      cards that are expired
    // filterAcceptedMethods is an array of the method types that
    //      want to be included in the result
    fetchSavedMethods: function fetchSavedMethods(filterExpired, filterAcceptedMethods) {
      return VuexStore.dispatch('fetchSavedMethods', {
        filterExpired: filterExpired,
        filterAcceptedMethods: filterAcceptedMethods
      });
    },
    // Get is returning the saved methods attached to the
    // current user in memory -- no request to the server
    getSavedMethods: function getSavedMethods() {
      return VuexStore.state.UsersStore.currentUser.savedMethods || [];
    },
    deleteSavedMethod: function deleteSavedMethod(id) {
      return VuexStore.dispatch('deleteSavedMethod', id);
    },
    addFeedback: function addFeedback(token, score, useNPS) {
      return VuexStore.dispatch('addFeedback', {
        token: token,
        score: score,
        useNPS: useNPS
      });
    },
    editFeedback: function editFeedback(id, token, score, comment, useNPS, reasons) {
      return VuexStore.dispatch('editFeedback', {
        id: id,
        token: token,
        score: score,
        comment: comment,
        useNPS: useNPS,
        reasons: reasons
      });
    },
    confirmPhoneGetCode: function confirmPhoneGetCode(phone, currentPassword) {
      return VuexStore.dispatch('confirmPhoneGetCode', {
        phone: phone,
        currentPassword: currentPassword
      });
    },
    confirmPhoneVerifyCode: function confirmPhoneVerifyCode(code) {
      return VuexStore.dispatch('confirmPhoneVerifyCode', code);
    },
    forgotPasswordGetCode: function forgotPasswordGetCode(email) {
      return VuexStore.dispatch('forgotPasswordGetCode', email);
    },
    forgotPasswordSendEmail: function forgotPasswordSendEmail(email) {
      return VuexStore.dispatch('forgotPasswordSendEmail', email);
    },
    forgotPasswordVerifyCode: function forgotPasswordVerifyCode(email, method, code) {
      return VuexStore.dispatch('forgotPasswordVerifyCode', {
        email: email,
        method: method,
        code: code
      });
    },
    verifyEmail: function verifyEmail(token, patientUserId) {
      return VuexStore.dispatch('verifyEmail', {
        token: token,
        patientUserId: patientUserId
      });
    },
    verifyPhone: function verifyPhone(code, patientUserId, phoneNumber) {
      return VuexStore.dispatch('verifyPhone', {
        code: code,
        patientUserId: patientUserId,
        phoneNumber: phoneNumber
      });
    },
    confirmEmailSendVerification: function confirmEmailSendVerification(email, currentPassword) {
      return VuexStore.dispatch('confirmEmailSendVerification', {
        email: email,
        currentPassword: currentPassword
      });
    },
    confirmEmailVerifyCode: function confirmEmailVerifyCode(code) {
      return VuexStore.dispatch('confirmEmailVerifyCode', code);
    },
    deactivateAccount: function deactivateAccount(currentPassword) {
      return VuexStore.dispatch('deactivateAccount', currentPassword);
    },
    disassociateAccount: function disassociateAccount(disassociateAccountId) {
      return VuexStore.dispatch('disassociateAccount', disassociateAccountId);
    }
  };
});